module.exports = __webpack_public_path__ + "media/images/countrysquared/bj-5c194c89dba4012c49199368f99d7a16.svg";